import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import { FaEdit } from "react-icons/fa";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Job ID</th>
        <th style={{width:'10%'}}>Job Title</th>
        <th className='d-none d-sm-table-cell' style={{width:'40%'}}>Job Description</th>
        <th className='d-none d-sm-table-cell' style={{width:'20%'}}>Start Date</th>
        <th className='d-none d-sm-table-cell' style={{width:'20%'}}>Due Date</th>
        <th style={{width:'5%'}}>{props.mode==0?'Edit':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.jobsObj) {
    const rows = props.jobsObj.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.jobtitle}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.jobdescription}
          </td>        
          <td className='d-none d-sm-table-cell'>  
            {new Date(row.jobstartdate).toUTCString().substring(0,16)}
          </td>   
          <td className='d-none d-sm-table-cell'>  
            {new Date(row.jobduedate).toUTCString().substring(0,16)}
          </td>  

          <td align='center'>  
            {(props.mode==0) &&
              <Button><Link to = {`/editjobpage/${row.id}`}><FaEdit color='white'/></Link></Button>          
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                console.log(row);
                props.onSelected(row.id,row.jobtitle,row.jobdescription,row.client.id,row.client.clientname);
                props.handleClose();
              }} variant='link' value={row.id}>Select</Button>
            } 
          </td>            
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the patient.
  </Tooltip>
);



const JobsList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline", marginLeft:"13px",width:"99%"}} striped bordered hover size="sm">
          <TableHeader mode={props.mode} />
            <TableBody handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} jobsObj={props.listOfJobs} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default JobsList;